import { QB_OPERATOR_TYPES, QB_FIELD_TYPES } from './types.js';

export const QB_DEFAULT_VALUES_OPTIONS = [
  {
    dsId: 'QB_DEFAULT_VALUES_OPTIONS_EMPTY',
    type: 'option',
    label: 'Choose a Field',
    value: '',
  },
];
export const QB_SUBJECT_VALUES_OPTIONS = [
  {
    dsId: 'Condominium',
    type: 'option',
    label: 'Condominium',
    value: 'Condominium',
  },
  {
    dsId: 'Single Family Home',
    type: 'option',
    label: 'Single Family Home',
    value: 'Single Family Home',
  },
  {
    dsId: 'Co-Operative',
    type: 'option',
    label: 'Co-Operative',
    value: 'Co-Operative',
  },
  {
    dsId: 'Detached',
    type: 'option',
    label: 'Detached',
    value: 'Detached',
  },
  {
    dsId: 'High Rise Condominium',
    type: 'option',
    label: 'High Rise Condominium',
    value: 'High Rise Condominium',
  },
  {
    dsId: 'Manufactured Housing',
    type: 'option',
    label: 'Manufactured Housing',
    value: 'Manufactured Housing',
  },
  {
    dsId: 'Other',
    type: 'option',
    label: 'Other',
    value: 'Other',
  },
];

export const QB_LOAN_VALUES_OPTIONS = [
  {
    dsId: 'Conventional',
    type: 'option',
    label: 'Conventional',
    value: 'Conventional',
  },
  {
    dsId: 'VA',
    type: 'option',
    label: 'VA',
    value: 'VA',
  },
  {
    dsId: 'FHA',
    type: 'option',
    label: 'FHA',
    value: 'FHA',
  },
  {
    dsId: 'USAD-RHS',
    type: 'option',
    label: 'USAD-RHS',
    value: 'USAD-RHS',
  },
  {
    dsId: 'HELOC',
    type: 'option',
    label: 'HELOC',
    value: 'HELOC',
  },
  {
    dsId: 'Other',
    type: 'option',
    label: 'Other',
    value: 'Other',
  },
];

export const QB_FIELD_OPTIONS = [
  {
    dsId: 'QB_FIELD_OPTIONS_EMPTY',
    type: 'option',
    label: 'Select',
    value: '',
  },
  {
    dsId: QB_FIELD_TYPES.LOAN_VALUES,
    type: 'option',
    label: 'Loan Type',
    value: QB_FIELD_TYPES.LOAN_VALUES,
  },
  {
    dsId: QB_FIELD_TYPES.LTV_VALUES,
    type: 'option',
    label: 'Loan To Value (LTV)',
    value: QB_FIELD_TYPES.LTV_VALUES,
  },
  {
    dsId: QB_FIELD_TYPES.SUBJECT_VALUES,
    type: 'option',
    label: 'Subject Property Type',
    value: QB_FIELD_TYPES.SUBJECT_VALUES,
  },
  {
    dsId: QB_FIELD_TYPES.LAST_VALUES,
    type: 'option',
    label: 'Last Finished Milestone',
    value: QB_FIELD_TYPES.LAST_VALUES,
  },
  {
    dsId: QB_FIELD_TYPES.CREDIT_VALUES,
    type: 'option',
    label: 'Credit Score',
    value: QB_FIELD_TYPES.CREDIT_VALUES,
  },
];

export const QB_OPERATOR_OPTIONS = [
  {
    dsId: 'QB_OPERATOR_OPTIONS_EMPTY',
    type: 'option',
    label: 'Select',
    value: '',
  },
  {
    dsId: QB_OPERATOR_TYPES.EQUAL,
    type: 'option',
    label: 'Is',
    value: QB_OPERATOR_TYPES.EQUAL,
  },
  {
    dsId: QB_OPERATOR_TYPES.NOT_EQUAL,
    type: 'option',
    label: 'Is not',
    value: QB_OPERATOR_TYPES.NOT_EQUAL,
  },
  {
    dsId: QB_OPERATOR_TYPES.GREATER_THAN,
    type: 'option',
    label: 'Greater than',
    value: QB_OPERATOR_TYPES.GREATER_THAN,
  },
  {
    dsId: QB_OPERATOR_TYPES.LESS_THAN,
    type: 'option',
    label: 'Less than',
    value: QB_OPERATOR_TYPES.LESS_THAN,
  },
  {
    dsId: QB_OPERATOR_TYPES.CONTAINS,
    type: 'option',
    label: 'Contains',
    value: QB_OPERATOR_TYPES.CONTAINS,
  },
  {
    dsId: QB_OPERATOR_TYPES.NOT_CONTAINS,
    type: 'option',
    label: "Doesn't Contain",
    value: QB_OPERATOR_TYPES.NOT_CONTAINS,
  },
  {
    dsId: QB_OPERATOR_TYPES.BETWEEN,
    type: 'option',
    label: 'Between',
    value: QB_OPERATOR_TYPES.BETWEEN,
  },
];
